import React from "react";
import HiFive from "../../assets/icons/HiFive";
import useRetailBusinessStatus from "../../hooks/invoice/useRetailBusinessStatus";
import { useUserStore } from "../../state";
import { isMobileDevice } from "../../utils";
import TourGuideComponent from "./SideBar";
import { useIsMobile } from "./useIsMobile";
import { useCompanyStore } from "../../state/useCompanyStore";

export const useDashboardTourGuide = () => {
  let dashboardTourGuide;
  const [isCollapsed, setIsCollapsed] = React.useState(true);
  const [showMobileMenu, setShowMobileMenu] = React.useState(false);
  const isRetailBusiness = useRetailBusinessStatus();
  const { company: user, setFirstLogin, updateProfile } = useCompanyStore();

  const tourGuideOptions = {
    showProgress: false,
    disableBeacon: true,
    styles: {
      tooltip: { background: "#ffffff" },
      beaconInner: { background: "#ffffff" },
    },
    placement: "right" as const,
    locale: {
      skip: (
        <span
          onClick={() => {
            updateProfile({ firstLogin: false });
            setIsCollapsed(true);
            setFirstLogin(false);
          }}
          className="text-[#344054]"
        >
          Skip
        </span>
      ),
      next: <span className="text-[#ffffff] bg-transparent">Next</span>,
    },
  };

  dashboardTourGuide = [
    {
      target: "#step-1",
      content: (
        <div className="flex items-start">
          <div className="mr-2">
            <HiFive />
          </div>
          <div>
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-[#1D2939] text-[16px] font-semibold">
                Welcome, {user?.firstName}
              </h3>
            </div>
            <p className="text-[#344054] text-justify font-medium text-[16px]">
              Ready to explore Esemie Tour guide? Let’s take a quick tour to
              help you get the most out of our app. Click the button to get
              started!
            </p>
          </div>
        </div>
      ),
      styles: {
        options: {
          width: 500,
        },
      },
      placement: "center" as const,
      hideCloseButton: true,
      showSkipButton: true,
      showProgress: false,
      locale: {
        next: (
          <p
            onClick={() => {
              setIsCollapsed(false);
              setShowMobileMenu(false);
            }}
          >
            Get Started
          </p>
        ),
        skip: (
          <span
            onClick={() => {
              updateProfile({ firstLogin: false });
              setFirstLogin(false);
            }}
          >
            Skip
          </span>
        ),
      },
    },
    {
      target: ".menu-item-1",
      content: (
        <TourGuideComponent
          body="This gives you the summary of transactions across the app."
          progress="Step 1 of 7"
          title="Dashboard"
        />
      ),
      hideBackButton: true,
      ...tourGuideOptions,
    },
    {
      target: ".menu-item-2",
      content: (
        <TourGuideComponent
          body="Send a invoice to request payment for your business or service provided as well as giving your customers an estimated price for goods or services."
          progress="Step 2 of 7"
          title="Invoicing & Quotes"
        />
      ),
      ...tourGuideOptions,
    },
    {
      target: ".menu-item-3",
      content: (
        <TourGuideComponent
          body="This lets you easily track and manage all your business spending in one place. Add, view expenses to keep your finances up to date."
          progress="Step 3 of 7"
          title="Expense"
        />
      ),
      ...tourGuideOptions,
    },
    {
      target: ".menu-item-4",
      content: (
        <TourGuideComponent
          body="Add and manage customer records. Useful for invoicing and accurate record keeping."
          progress="Step 4 of 7"
          title="Customer"
        />
      ),
      ...tourGuideOptions,
    },
    {
      target: ".menu-item-5",
      content: (
        <TourGuideComponent
          body={
            isRetailBusiness
              ? "This helps you track and manage stock levels to keep products updated and avoid shortages or excess."
              : "This helps you track and manage stock levels to keep services updated."
          }
          progress="Step 5 of 7"
          title={isRetailBusiness ? "Inventory" : "Services"}
        />
      ),
      ...tourGuideOptions,
    },
    {
      target: ".menu-item-6",
      content: (
        <TourGuideComponent
          body="This provides key insights like profit & loss and expenses to help you track your business performance."
          progress="Step 6 of 7"
          title="Reports"
        />
      ),
      ...tourGuideOptions,
    },
    {
      target: ".menu-item-7",
      content: (
        <TourGuideComponent
          body="This lets you manage staff access and permissions, ensuring the right team members have the right tools to work efficiently."
          progress="Step 7 of 7"
          title="Users"
        />
      ),
      placement: "right" as const,
      locale: {
        skip: (
          <span
            onClick={() => {
              updateProfile({ firstLogin: false });
              setFirstLogin(false);
            }}
            className="text-[#344054]"
          >
            Skip
          </span>
        ),
        next: <span className="text-[#ffffff] bg-transparent">Next</span>,
        last: (
          <span
            onClick={() => {
              updateProfile({ firstLogin: false });
              setIsCollapsed(true);
              setFirstLogin(false);
            }}
            className="text-[#ffffff] bg-transparent"
          >
            Finish up
          </span>
        ),
      },
      showProgress: false,
      styles: {
        tooltip: { background: "#ffffff" },
        beaconInner: { background: "#ffffff" },
      },
    },
  ];

  return {
    dashboardTourGuide,
    setIsCollapsed,
    isCollapsed,
    showMobileMenu,
    setShowMobileMenu,
  };
};
